import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import 'tippy.js/themes/light-border.css'

import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

// Connects to data-controller="disabled-tooltip"
export default class extends Controller {
  static targets = [
    'anchorElement',
    'triggerElement',
  ]

  declare readonly anchorElementTarget: HTMLElement
  declare readonly triggerElementTarget: HTMLElement

  static values = {
    content: String,
  }

  declare contentValue: string

  connect () {
    const instance = tippy(this.anchorElementTarget, {
      content: this.contentValue,
      theme: 'light-border',
      animation: 'shift-away',
    })

    if (!this.triggerElementTarget.hasAttribute('disabled')) {
      instance.disable()
    }
  }
}
